import { render, staticRenderFns } from "./SnsIndex.vue?vue&type=template&id=12b3878c&scoped=true"
import script from "./SnsIndex.vue?vue&type=script&lang=js"
export * from "./SnsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b3878c",
  null
  
)

export default component.exports